import React, { useState, useEffect, useContext } from "react";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import Lists from "./_lists/Lists";
import CardItems from "./CardItems";
import MainBodyTabs from "./financeTabs";
import MainTitle from "../common/MainTitle";
import MainPrintLink from "../common/MainPrint";
import { isFinanceReadOnly } from "../../utils/financeAccess";

import { HalfYearContext } from "../../contexts/halfYearContext";

const FinanceExpenses = (props) => {
  const { match } = props;

  const [tabs, setTabs] = useState([]);
  const { halfYear } = useContext(HalfYearContext);

  const routeTabs = [
    {
      name: "مصرف ها",
      path: "/mis/expenses/1",
    },
    {
      name: "بودجه ها",
      path: "/mis/expenseBudgets",
    },
    {
      name: "طرف های قرارداد",
      path: "/mis/contractors",
    },
    {
      name: "حسابات قبلی استادان",
      path: "/mis/facultiesPastBalance",
    },
    {
      name: "امتیازات استادان",
      path: "/mis/teacherBenefits",
    },
  ].filter((tab) => {
    if (!isFinanceReadOnly()) return true;
    return false;
  });

  useEffect(async () => {
    const ac = new AbortController();

    await db.getAll("expenses/types").then(({ data }) => {
      if (!isFinanceReadOnly()) {
        setTabs(data);
        return;
      }
      const rows = Array.isArray(data?.data) ? data.data : [];
      setTabs({
        ...data,
        data: rows.filter((t) => [3, 4, 5].includes(Number(t.id))),
      });
    });

    return () => ac.abort();
  }, [halfYear]);

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainTitle title={lbl.ExpenseAccounts} />
        </div>
        <div className="left-content">
          <MainPrintLink path={`expenses/${match.params.tid}/${halfYear}`} />
        </div>
      </div>
      <div className="main-content-body">
        {!isFinanceReadOnly() && <MainBodyTabs tabs={routeTabs} {...props} />}
        <CardItems
          cards={tabs.data}
          restClass={`mt-25`}
          currentTab={match.params.tid}
          path="expenses"
        />

        <Lists currentTab={match.params.tid} />
      </div>
    </div>
  );
};

export default FinanceExpenses;
